exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body .icerik[data-v-53d9b7f7]{height:100vh!important}.SpotlightKutu[data-v-53d9b7f7]{z-index:2}.body.vezne[data-v-53d9b7f7]{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53d9b7f7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Panel/Veznedar.vue
// module id = 624
// module chunks = 0